// extracted by mini-css-extract-plugin
export default {"cyclingTitle":"CyclingTitle_cyclingTitle__gEiY+","word":"CyclingTitle_word__8gAOd","dot":"CyclingTitle_dot__m6B6j","suffix":"CyclingTitle_suffix__h9X21"};